import { PUBLIC_URL } from '../../utils/constants';

export default {
  CONTACT_INQUIRY_LISTING: `${PUBLIC_URL}/contactInquiry`,
  HELP_CENTER: `${PUBLIC_URL}/help-center`,
  HELP_CENTER_CONVERSATIONS: `${PUBLIC_URL}/help-center/conversations`,

  CONSULTATIONS_LIST: `${PUBLIC_URL}/consultation`,
  CONSULTATIONS_CONVERSATIONS: `${PUBLIC_URL}/consultation/conversations`,
  CONSULTATION_DETAILS: `${PUBLIC_URL}/consultation/:id`,
};
